const maxTime = 500;
const readyStates = ['interactive', 'complete'];

const onReady = (f) => {
  if (readyStates.indexOf(document.readyState) !== -1) f();
  else window.addEventListener('DOMContentLoaded', f);
};

const init = (() => {
  let metricsPromise;
  return () => {
    if (!metricsPromise) {
      metricsPromise = new Promise((resolve) => {
        onReady(() => {
          let metrics;
          if (process.env.NODE_ENV === 'production') {
            ({ metrics } = window);
          } else {
            /* eslint-disable no-console */
            metrics = {
              init: (data) => {
                console.log('init', data);
              },
              click: (data, el, resolver) => {
                console.log('click', data);
                setTimeout(resolver, Math.random() * maxTime * 2);
              },
              view: (data) => {
                console.log('view', data);
              },
            };
            /* eslint-enable no-console */
          }
          if (metrics) {
            metrics.init({ noview: true });
            resolve(metrics);
          } else {
            // const err = new Error('window.metrics not defined on init');
            // logger.error(err);
            const noop = () => {};
            resolve({
              init: noop,
              view: noop,
              click: (data, el, resolver) => {
                if (resolver) resolver();
              },
            });
          }
        });
      });
    }
    return metricsPromise;
  };
})();

function view(data) {
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, maxTime);
    Promise.resolve(init()).then((metrics) => {
      metrics.view(data);
      clearTimeout(timeout);
      resolve();
    });
  });
}

function click(data) {
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, maxTime);
    Promise.resolve(init()).then((metrics) => {
      metrics.click(data, null, () => {
        clearTimeout(timeout);
        resolve();
      });
    });
  });
}

export default { click, view };
